import 'picturefill';
import Swiper from 'swiper/dist/js/swiper.min.js';

// チェックボックスの変更監視
const chk = document.querySelector('#termscheck');  // チェックボックスオブジェクト
if (chk) {
  const btn = document.querySelector('#submit-btn');  // チェックボックスオブジェクト
  chk.addEventListener('change', (event) => {
    // 選択状態を確認する
    if (event.target.checked) {
      // チェックありの場合
      btn.disabled = false;
    }
    else {
      // チェックなしの場合
      btn.disabled = true
    }
  });
}

// 販社・店舗の変更監視
const cpny = document.querySelector('#company');
const shopOpt = $("#shop option");
if (cpny && shopOpt) {
  cpny.addEventListener('change', (event) => {
    // 値を取得
    const value = cpny.value;

    // 表示・非表示を設定する
    // select要素の中の全てのspan要素を削除
    var spans = $("#shop span");
    for (var i = 0; i < spans.length; i++) {
      spans.eq(i).children().unwrap();
    }

    // 対象のoptionをspan要素で囲む
    for (var i = 1; i < shopOpt.length; i++) {
      if (shopOpt[i].dataset.parent !== value) {
        shopOpt.eq(i).wrap('<span style="display: none;"></span>');
      }
      shopOpt.eq(i).prop("selected", false);
    }
    shopOpt.eq(0).prop("selected", true);
  });
}

// 来店予定日の変更監視
const month = document.querySelector('#month');
const day = document.querySelector('#day');
const dayOpt = $("#day option");
if (month && dayOpt) {
  month.addEventListener('change', (event) => {
    // 値を取得
    const value = month.value;
    let dayNo = parseInt(day.value);
    if (!dayNo) {
      dayNo = 0;
    }

    // 表示・非表示を設定する
    // select要素の中の全てのspan要素を削除
    var spans = $("#day span");
    for (var i = 0; i < spans.length; i++) {
      spans.eq(i).children().unwrap();
    }

    switch (value) {
      case '4':
      case '6':
      case '9':
      case '11':
        if (dayNo > 30) {
          dayOpt.eq(0).prop("selected", true);
        }
        for (let i = 31; i < dayOpt.length; i++) {
          dayOpt.eq(i).wrap('<span style="display: none;"></span>');
          dayOpt.eq(i).prop("selected", false);
        }
        break;
      case '2':
        if (dayNo > 29 ) {
          dayOpt.eq(0).prop("selected", true);
        }
        for (let i = 30; i < dayOpt.length; i++) {
          dayOpt.eq(i).wrap('<span style="display: none;"></span>');
          dayOpt.eq(i).prop("selected", false);
        }
        break;
      default:
        break;
    }
  });
}

// ************************************
// 画面の初期化処理
// ************************************
function init() {
  // 販社・店舗の変更監視
  if (cpny && shopOpt) {
    // 値を取得
    const value = cpny.value;
    if (value != "") {
      // 表示・非表示を設定する
      // 対象のoptionをspan要素で囲む
      for (var i = 1; i < shopOpt.length; i++) {
        if (shopOpt[i].dataset.parent !== value) {
          shopOpt.eq(i).wrap('<span style="display: none;"></span>');
        }
      }
    }
  }

  // 来店予定日の変更監視
  if (month && dayOpt) {
    // 値を取得
    const value = month.value;
    let dayNo = parseInt(day.value);
    if (!dayNo) {
      dayNo = 0;
    }

    // 表示・非表示を設定する
    switch (value) {
      case '4':
      case '6':
      case '9':
      case '11':
        for (let i = 31; i < dayOpt.length; i++) {
          dayOpt.eq(i).wrap('<span style="display: none;"></span>');
          dayOpt.eq(i).prop("selected", false);
        }
        break;
      case '2':
        for (let i = 30; i < dayOpt.length; i++) {
          dayOpt.eq(i).wrap('<span style="display: none;"></span>');
          dayOpt.eq(i).prop("selected", false);
        }
        break;
      default:
        break;
    }
  }

  // スワイパー設定
  const mySwiper = new Swiper('.car-list', {
    // オプション
    loop: true, // 一番最後まで行ったときに最初に戻る（true）か戻らない（false）か
    autoplay: { // 自動再生
      delay: 5000, // 間隔（ミリ秒）
      disableOnInteraction: false // 操作されたら自動再生をストップさせる（true）設定（規定値true）
    },
    slidesPerView: 3, // 1画面に表示するスライドの枚数
    centeredSlides: true,
    spaceBetween: 0, // スライド同士の距離（px）
    speed: 1000, // スライドが移動する時間（ミリ秒）（規定値は300ms）
    // ページネーション
    pagination: {
      el: '.swiper-pagination',
      clickable: true, //クリックに反応させる
    },
    // ナビゲーションボタン（前に戻るボタン、次に進むボタン）
    navigation: {
      nextEl: '.swiper-button-next',    // 次に進むボタン（矢印）要素
      prevEl: '.swiper-button-prev',    // 前に戻るボタン（矢印）要素
    },
    breakpoints: {
      // スライドの表示枚数：500px以上の場合
      768: {
        slidesPerView: 1,
      }
    }
  });
}
init();

// ************************************
// スムーススクロール
// ************************************
$('a[href^="#"]:not([href="#"])').on('click', function() {
  let target = 0;
  if ($(this).attr('href') !== "#top") {
    target = $($(this).attr('href')).offset().top;
    target = target;
  }
  $('html, body').animate({scrollTop: target}, 700);
  return false;
});
// ************************************
// TOP画面のアコーディオン
// ************************************
if ($('main').hasClass('top') === true) {
  $('.js-ac-btn').on('click', function() {
    $(this).siblings('.js-ac-contents').stop().slideToggle(300);
    $(this).toggleClass('js-ac-open');
  });
  $('.js-ac-close').on('click', function() {
    $(this).parent('.js-ac-contents').stop().slideToggle(300);
    $(this).parent('.js-ac-contents').siblings('.js-ac-btn').toggleClass('js-ac-open');
  });
}
